$(document).on('turbo:load', function () {
    const page = $('.admin-momentum-resources');

    const fileTypeSelect = page.find('#file_type_select');
    const urlField = page.find('#url_field');
    const fileUploadField = page.find('#file_upload_field');

    function toggleFields() {
        const selected = fileTypeSelect.val();

        if (selected === 'link' || selected === 'video') {
            urlField.show();
            fileUploadField.hide();
        } else if (selected === 'document') {
            urlField.hide();
            fileUploadField.show();
        } else {
            urlField.hide();
            fileUploadField.hide();
        }
    }

    if (fileTypeSelect.length) {
        toggleFields(); // initialize on page load
        fileTypeSelect.on('change', toggleFields);
    }
});
